module.exports = __webpack_public_path__ + "media/mexico.e25a41de.png";